import { createAsyncSlice } from 'store/createAsyncSlice';
import { updateAchPushAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: updateAchPushSlice, asyncAction: updateAchPushAction } = createAsyncSlice(
  'updateAchPushSlice',
  updateAchPushAsync
);
